import styled,{css}from 'styled-components';
export const Container = styled.div`
  display: flex;
  width: 100%;
  max-height: 30rem;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  .title{
    position: relative;
    display: flex;
    width: 100%;
    min-height: 3rem;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-weight: bold;
    border-radius: 4px;
    background-color: #1D86FF;
    cursor: pointer;
    user-select: none;
    .icon--{
      position: absolute;
      display: flex;
      width: 3rem;
      height: 100%;
      right: 0;
      justify-content: center;
      align-items: center;
      font-size: 1.5rem;
    }
    ${({isOpen})=> isOpen &&
      css`
      border-radius: 4px 4px 0 0;
      `
    }
  }

  .content{
    display: flex;
    width: 100%;
    height: 0.1px;
    max-height: 30rem;
    border-radius: 0 0 4px 4px;

    ${({isOpen})=> isOpen &&
      css`
        padding: 1rem;
        height: auto;
        overflow-y:auto;
        border: 1.5px solid #1D86FF; 
      `
    }

    &::-webkit-scrollbar{
      width: 5px;
      height: 5px;
    }
    &::-webkit-scrollbar-thumb{
      background-color: rgb(0, 0, 0,0.2);
    }
  }



`